import { render, staticRenderFns } from "./Djradio.vue?vue&type=template&id=6b61fbd0&scoped=true"
import script from "./Djradio.vue?vue&type=script&lang=js"
export * from "./Djradio.vue?vue&type=script&lang=js"
import style0 from "./Djradio.vue?vue&type=style&index=0&id=6b61fbd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61fbd0",
  null
  
)

export default component.exports